import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=7f8add9b"
import script from "./PurchaseHistory.vue?vue&type=script&lang=ts"
export * from "./PurchaseHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports